import React from "react";
import DashboardLabel from "src/components/label/DashboardLabel";
import UpDownLabel from "src/components/label/UpDownLabel";
import ValueLabel from "src/components/label/ValueLabel";
import Devider from "src/components/ui/Divider";
import TodayIcon from "src/components/icon/TodayIcon";

interface StatItem {
  label: string;
  value?: number;
  icon?: number;
  change?: number;
}

interface DashboardCardProps {
  stats: StatItem[];
}

const DashboardCard: React.FC<DashboardCardProps> = ({ stats }) => {
  return (
    <div className="stats-bar pb-3 mb-3">
      {stats.map((stat, index) => (
        <React.Fragment key={index}>
        <div className="stat-item w-100">
          <div className="d-flex align-items-center justify-content-between w-100">
            <DashboardLabel label={stat.label} />
            {typeof stat.icon === "number" && <TodayIcon icon={stat.icon} />}
            {stat.value && 
              <ValueLabel value={stat.value}>
                {stat.change && <UpDownLabel change={stat.change} label={stat.label} />}
              </ValueLabel>
            }
          </div>
        </div>
        {index < stats.length - 1 && <Devider />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default DashboardCard;
